var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['help-div' ,_vm.position],on:{"click":function($event){return _vm.$emit('closeLabel')}}},[_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }